//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

//项目额度列表
const projectList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/project/projectList.vue')),
    'projectMaintainList'
  );

//信用额度新增
// const projectAdd = (r) =>
//   require.ensure([], () => r(require('@/pages/purchaseSalesCenter/project/add.vue')), 'projectAdd');

//信用额度新增
const projectEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/project/edit.vue')),
    'projectEdit'
  );
//信用额度统计
// const projectTotal = (r) =>
//   require.ensure(
//     [],
//     () => r(require('@/pages/purchaseSalesCenter/project/totalList.vue')),
//     'projectTotal'
//   );
//项目额度分析
const projectAnalysis = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/project/totalDetail.vue')),
    'projectAnalysis'
  );

const projectQuotaRouter = {
  path: '/project',
  component: index,
  children: [
    {
      path: 'projectMaintainList',
      name: 'projectMaintainList',
      component: projectList,
      meta: {
        keepAlive: true,
        title: '项目额度列表',
      },
    },
    {
      path: 'projectAdd',
      name: 'projectAdd',
      component: () => import('@/pages/purchaseSalesCenter/project/add.vue'),
      meta: {
        keepAlive: true,
        title: '项目额度新增',
      },
    },
    {
      path: 'projectTemporaryAdd',
      name: 'projectTemporaryAdd',
      component: () => import('@/pages/purchaseSalesCenter/project/temporaryLimit/index.vue'),
      meta: {
        keepAlive: true,
        title: '临时额度新增',
      },
    },
    {
      path: 'projectTemporaryEdit',
      name: 'projectTemporaryEdit',
      component: () => import('@/pages/purchaseSalesCenter/project/temporaryLimit/index.vue'),
      meta: {
        keepAlive: true,
        title: '临时额度修改',
      },
    },
    {
      path: 'projectTemporaryDetail',
      name: 'projectTemporaryDetail',
      component: () => import('@/pages/purchaseSalesCenter/project/temporaryLimit/index.vue'),
      meta: {
        keepAlive: true,
        title: '临时额度详情',
      },
    },
    {
      path: 'projectEdit',
      name: 'projectEdit',
      component: projectEdit,
      meta: {
        keepAlive: true,
        title: '项目额度修改',
      },
    },
    {
      path: 'projectTotal',
      name: 'projectTotal',
      component: () => import('@/pages/purchaseSalesCenter/project/totalList.vue'),
      meta: {
        keepAlive: true,
        title: '项目额度统计',
      },
    },
    {
      path: 'projectAnalysis',
      name: 'projectAnalysis',
      component: projectAnalysis,
      meta: {
        keepAlive: true,
        title: '项目额度分析',
      },
    },
  ],
};
export default projectQuotaRouter;
